import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function PaymentCancel() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const product = params.get('product') || 'masterclass_3day';
  const target = product.startsWith('training_')
    ? { to: '/training', label: t('payment.retryTraining') }
    : product.startsWith('selection_')
      ? { to: '/selection-payment', label: t('payment.retrySelection') }
      : { to: '/masterclass', label: t('payment.retry') };

  return (
    <main className="min-h-screen flex items-center justify-center px-4 pt-16" data-testid="payment-cancel-page">
      <div className="max-w-lg w-full rounded-xl border border-slate-700/70 bg-[#1E293B] p-10 text-center">
        <XCircle className="w-16 h-16 mx-auto text-rose-400" />
        <h1 className="mt-6 font-display text-4xl text-white" data-testid="payment-cancel-title">
          {t('payment.cancelTitle')}
        </h1>
        <p className="mt-4 text-sm text-slate-400 leading-relaxed">{t('payment.cancelText')}</p>
        <Link
          data-testid="payment-retry-btn"
          to={target.to}
          className="mt-8 inline-flex items-center gap-2 rounded-lg bg-green-500 px-7 py-3.5 text-base font-semibold text-white transition-all duration-300 hover:bg-green-400 hover:shadow-[0_0_30px_rgba(34,197,94,0.45)]"
        >
          {target.label}
        </Link>
      </div>
    </main>
  );
}
